export const dashRoutes = [
  {
    path: 'dashboard',
    loadComponent: () => import('./general-dashboard/general-dashboard').then((m) => m.GeneralDashboard),
    data: { moduleCode: 'dash_dash' }
  },
  {
    path: 'license-dashboard',
    loadComponent: () => import('./license-dashboard/license-dashboard').then((m) => m.LicenseDashboard),
    data: { moduleCode: 'dash_lic_dash' }
  }
];
